<template>
    <VJoyIcon :size="size" :name="familyIcon" :color="color" data-testid="family-icon" />
</template>

<script setup lang="ts">
    import {computed, toRefs} from 'vue';
    import {useFeatureFlag} from '@malt/feature-flags';
    import type {TJoyIconsColors} from '@maltjoy/core-vue';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';

    type Props = {
        size: 'xsmall' | 'small';
        family: string;
        color?: TJoyIconsColors;
    };
    const props = defineProps<Props>();
    const {family} = toRefs(props);

    const isRevampedCategorySection = useFeatureFlag('enable-category-section-revamp');

    const familyLogo: Record<string, JoyIconsId> = {
        business_consulting: 'company-placeholder',
        communication: 'communication',
        data: 'dataviz',
        industrial_engineering: 'r2d2',
        marketing: 'marketing',
        other: 'three-dots',
        picture_sound: 'play',
        projectmanagers_agilecoaches: 'projectmanager-agile',
        support_functions: 'users',
        tech: 'xml',
        video_games: 'videogame',
        web_graphic_design: 'web-design',
    };

    const oldAssociations: Record<string, any> = {
        business_consulting: 'fee',
        communication: 'communication',
        data: 'dataviz',
        'industrial-engineering': 'r2d2',
        marketing: 'marketing',
        other: 'dots-vertical',
        'picture-sound': 'picture-sound',
        'projectmanagers-agilecoaches': 'projectmanager-agile',
        'support-functions': 'users',
        developers_datascientists: 'xml',
        'video-games': 'videogame',
        graphicdesigners_photographers: 'web-design',
    };

    const familyIcon = computed(() => {
        return (isRevampedCategorySection.value ? familyLogo[family.value] : oldAssociations[family.value]) || 'company-placeholder';
    });
</script>
